module.exports = __webpack_public_path__ + "static/media/GT40_.dc83c080.png";